import React from 'react';
import { Filter, X } from 'lucide-react';
import styles from './DashboardFilterChip.module.css';

/** One applied filter in words, with how to take just it off. */
export interface DashboardFilterDetail {
  key: string;
  text: string;
  onClear: () => void;
}

interface DashboardFilterChipProps {
  onReset: () => void;
  /** What the filters mean, in words, so the user can see what the list is narrowed to; each can be cleared alone. */
  details?: DashboardFilterDetail[];
}

const DashboardFilterChip: React.FC<DashboardFilterChipProps> = ({ onReset, details = [] }) => (
  <div className={styles.chip} role="status" data-test-id="dashboard-filter-chip">
    <Filter size={14} aria-hidden="true" />
    <span>Filtered from dashboard{details.length > 0 && ':'}</span>
    {details.map((detail) => (
      <span key={detail.key} className={styles.detail} data-test-id={`dashboard-filter-detail-${detail.key}`}>
        {detail.text}
        <button
          type="button"
          className={styles.clear}
          onClick={detail.onClear}
          aria-label={`Clear ${detail.text}`}
          data-test-id={`dashboard-filter-clear-${detail.key}`}
        >
          <X size={12} aria-hidden="true" />
        </button>
      </span>
    ))}
    <button type="button" className={styles.reset} onClick={onReset}>
      <X size={14} aria-hidden="true" />
      Reset
    </button>
  </div>
);

export default DashboardFilterChip;
